'use client';

import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import {
  ro,
  Ja,
  Ya,
  useChatMessages,
  Xa,
  B,
  qa,
  Ga,
  Ka,
  Za,
} from './chat-messages';
import { ImaiAvatar, Oa, ImaiStatus, ChatMessage } from './approvals-animation';
import {
  useBusinessPlayback,
  typedText,
  BusinessComposer,
} from './business-primitives';
import { Se } from './business-facts';
export function ChatSidebar({ thread: e, status: t }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <nav
      aria-label={translateShowcaseNode(showcaseCopy, 'Chats')}
      className={
        'hidden w-[232px] shrink-0 flex-col gap-px border-r border-[var(--line)] bg-[color-mix(in_oklch,var(--muted)_55%,var(--background))] p-2 md:flex'
      }
    >
      <span className={`${ro} text-ink-2`}>
        <ShowcaseIcon name={'pen'} className={'size-[17px]'} />
        {translateShowcaseNode(showcaseCopy, 'New chat')}
      </span>
      <span className={`${ro} text-ink bg-[var(--state-wash)] font-medium`}>
        <span className={'grid size-[17px] place-items-center'}>
          <ImaiAvatar svg={Oa} size={16} />
        </span>
        {translateShowcaseNode(showcaseCopy, 'Your IMAI')}
      </span>
      <span className={`${ro} text-ink-2`}>
        <ShowcaseIcon name={'search'} className={'size-[17px]'} />
        {translateShowcaseNode(showcaseCopy, 'Search')}
      </span>
      <p className={'text-ink-4 mt-3 flex h-9 items-center px-2.5 text-[13px]'}>
        {translateShowcaseNode(showcaseCopy, 'Chats')}
      </p>
      {translateShowcaseNode(
        showcaseCopy,
        e ? (
          <div className={'bz-grow'}>
            <div className={'min-w-0'}>
              <span className={`${ro} bz-recv text-ink-2 w-full`}>
                <span className={'min-w-0 flex-1 truncate'}>
                  {translateShowcaseNode(showcaseCopy, Ja)}
                </span>
                {translateShowcaseNode(
                  showcaseCopy,
                  t === 'done' ? (
                    <span
                      className={
                        'inline-flex size-3 shrink-0 items-center justify-center'
                      }
                    >
                      <span
                        className={
                          'size-2 rounded-full bg-blue-500 ring-1 ring-blue-600/15'
                        }
                      />
                    </span>
                  ) : (
                    <ImaiStatus
                      awaiting={t === 'needs'}
                      className={'size-4 shrink-0'}
                    />
                  )
                )}
              </span>
            </div>
          </div>
        ) : null
      )}
      {translateShowcaseNode(
        showcaseCopy,
        [
          'Department store order, 400 units',
          'LISI\xC8RE FW27 line plan',
          'LISI\xC8RE: The finished edge',
        ].map((e) => (
          <span key={e} className={`${ro} text-ink-2`}>
            <span className={'min-w-0 truncate'}>
              {translateShowcaseNode(showcaseCopy, e)}
            </span>
          </span>
        ))
      )}
    </nav>
  );
}
export function YourImaiAnimation({ running: e, onDone: t }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let { t: n } = useBusinessPlayback(Ya, {
      running: e,
      onDone: t,
    }),
    r = useChatMessages(n).filter(
      (e) => n >= e.at && (e.until === void 0 || n < e.until)
    ),
    i = Xa.some(([e, t]) => n >= e && n < t),
    a =
      n >= B.answerType && n < B.answerSend
        ? typedText(qa, n, B.answerType, 22)
        : n >= B.askType + 260 && n < B.askSend
          ? `${Ga}${typedText(Ka.slice(Ga.length), n, B.askType + 260, 30)}`
          : '',
    o =
      (n >= B.askSend - 160 && n < B.askSend) ||
      (n >= B.answerSend - 160 && n < B.answerSend);
  return (
    <div className={'p-2 md:p-4'}>
      <div
        className={
          'flex h-[540px] overflow-hidden rounded-[10px] bg-[var(--background)] shadow-[var(--sh-1)] md:h-[660px]'
        }
      >
        <ChatSidebar thread={n >= B.thread} status={Za(n)} />
        <div className={'relative flex min-w-0 flex-1 flex-col'}>
          <header
            className={
              'pointer-events-none absolute inset-x-0 top-0 z-10 flex justify-center pt-2'
            }
          >
            <span
              className={'flex flex-col items-center gap-1 px-2 pt-0.5 pb-1'}
            >
              <span
                className={
                  '[filter:drop-shadow(0_1px_1px_rgb(0_0_0/0.22))_drop-shadow(0_3px_8px_rgb(0_0_0/0.28))]'
                }
              >
                <ImaiAvatar svg={Oa} size={40} />
              </span>
              <span
                className={
                  'flex max-w-56 flex-col items-center rounded-lg bg-[var(--background)] px-2 py-0.5 shadow-[var(--popover-shadow)]'
                }
              >
                <span className={'text-ink text-[12px] leading-4 font-medium'}>
                  {translateShowcaseNode(showcaseCopy, 'IMAI')}
                </span>
                <span
                  className={
                    'text-ink-3 grid text-[12px] leading-4 transition-[grid-template-rows,opacity] duration-200'
                  }
                  style={{
                    gridTemplateRows: i ? '1fr' : '0fr',
                    opacity: +!!i,
                  }}
                >
                  <span className={'overflow-hidden'}>
                    {translateShowcaseNode(showcaseCopy, 'Thinking')}
                  </span>
                </span>
              </span>
            </span>
          </header>
          <div
            role={'log'}
            aria-label={translateShowcaseNode(
              showcaseCopy,
              'Conversation with IMAI'
            )}
            className={
              'flex min-h-0 flex-1 flex-col justify-end overflow-hidden [mask-image:linear-gradient(to_bottom,transparent_92px,#000_150px)] px-4 pt-24'
            }
          >
            <div className={'mx-auto w-full max-w-[560px] pb-2'}>
              {translateShowcaseNode(
                showcaseCopy,
                r.map((e) => (
                  <ChatMessage key={e.key} from={e.from}>
                    {translateShowcaseNode(showcaseCopy, e.node)}
                  </ChatMessage>
                ))
              )}
            </div>
          </div>
          <div className={'shrink-0 px-3 pt-1 pb-3 md:px-4 md:pb-4'}>
            <BusinessComposer
              className={'mx-auto max-w-[560px]'}
              placeholder={'Text IMAI'}
              text={a}
              typing={a.length > 0}
              pressed={o}
              token={Ga}
            />
          </div>
        </div>
      </div>
      <ul className={'mt-3 grid gap-x-6 gap-y-1 px-1 md:grid-cols-2'}>
        {translateShowcaseNode(
          showcaseCopy,
          Se.yourImai.facts
            .filter((e, t) => t !== 1)
            .map((e) => (
              <li
                key={e}
                className={'text-ink-3 flex gap-2 text-[12.5px] leading-[1.5]'}
              >
                <span
                  className={'bg-ink-4 mt-[8px] size-1 shrink-0 rounded-full'}
                />
                {translateShowcaseNode(showcaseCopy, e)}
              </li>
            ))
        )}
      </ul>
    </div>
  );
}
